import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'
import { publicFaqExtendedItems } from '../../marketing/publicFaqExtended'

const WIRE_CUSTOMER_CENTER_NOTICE = '현재 전화 상담은 준비 중입니다. 카카오톡 채널이나 고객 문의 게시판을 이용해 주세요.'

export default function SupportHubPage() {
  const previewFaqs = publicFaqExtendedItems.slice(0, 5)

  React.useEffect(() => {
    window.alert(WIRE_CUSTOMER_CENTER_NOTICE)
  }, [])

  return (
    <MarketingSiteLayout>
      <div className="mx-auto max-w-4xl px-4 py-14 md:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-brand-sky">FAQ</p>
        <h1 className="mt-4 text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">자주 묻는 질문</h1>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-slate-600">
          도입 전 자주 확인하는 질문을 먼저 정리했습니다. 조직 도입, 요금, 계정 발급처럼 상황에 따라 달라지는
          내용은 문의로 남겨주시면 운영 방식에 맞춰 안내드립니다.
        </p>

        <div className="mt-10 divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white">
          {previewFaqs.map((item) => (
            <section key={item.question} className="px-6 py-6 sm:px-8">
              <h2 className="text-base font-bold text-slate-900">{item.question}</h2>
              <p className="mt-3 text-sm leading-7 text-slate-600">{item.answer}</p>
            </section>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/support/faq"
            className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-5 text-sm font-semibold text-slate-800 transition hover:border-sky-200 hover:bg-sky-50"
          >
            FAQ 전체 보기
          </Link>
          <Link
            to={PUBLIC_INQUIRY_PATH}
            className="inline-flex min-h-[44px] items-center justify-center rounded-lg bg-brand-navy px-5 text-sm font-bold text-white shadow-sm transition hover:bg-sky-700"
          >
            도입 문의하기
          </Link>
        </div>

        <div className="mt-12 rounded-lg bg-slate-50 p-6 text-sm leading-7 text-slate-600">
          로그인 후 이용 중인 고객 문의는 <Link to="/support/inquiries" className="font-semibold text-brand-navy hover:underline">고객 문의</Link>에서
          비공개로 접수하고 답변을 확인할 수 있습니다.
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
